module.exports = __webpack_public_path__ + "static/media/lisa-lose.f7bea11e.png";